import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getVersion} from "./versionApi";
import {Status} from "../../infrastructure/status";
import {type WithState} from "../../store/utils";

export interface VersionState {
  version: string;
  status: Status;
}

const initialState: VersionState = {
  version: "",
  status: Status.IDLE
};

export const getVersionAsync = createAsyncThunk(
  "version/getVersion",
  async (_, {fulfillWithValue, rejectWithValue}) => {
    try {
      const response = await getVersion();
      return fulfillWithValue(response.data?.data);
    } catch (err) {
      return rejectWithValue({});
    }
  }
);

export const versionSlice = createSlice({
  name: "version",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getVersionAsync.pending, state => {
        state.status = Status.LOADING;
      })
      .addCase(getVersionAsync.fulfilled, (state, action) => {
        state.status = Status.IDLE;
        state.version = action.payload.version;
      })
      .addCase(getVersionAsync.rejected, state => {
        state.status = Status.FAILED;
      });
  }
});

export const selectVersion = (state: WithState<VersionState, "version">) => state.version.version;
export const selectStatus = (state: WithState<VersionState, "version">) => state.version.status;

export const versionReducer = versionSlice.reducer;
